import React, { useState, useRef, useEffect } from "react";
import OverlayContainer from "@components/Overlay/OverlayContainer";
import ReplyModal from "./ReplyModal";
import axiosInstance from "../../../../axios";
import moment from "moment/moment";
import { getS3URL } from "../../../../_helpers";
import { useSelector } from "react-redux";
import ForumReplies from "./ForumReplies";
import { Loading } from "../../../Other/Loading";
import { FileViewer } from "react-file-viewer";
import ChapterDocument from "../../../Courses/CourseDetails/CourseChapterDetails/chapterDocument";

const PostComments = ({
  element,
  fetchUserForumPosts,
  setForumsHeaderDetails,
  studentPurchasedCourseDetails,
  setForumsInterrogate,
  forumId,
  setForumId,
}) => {
  const wrapperRef = useRef(null);
  const { REACT_APP_LOGIN_API_BASEURL } = process.env;
  const submissionPopUpCheckmarkUrl = `${process.env.REACT_APP_SMIK_API_BASEURL}/icons/icon-complete-check.svg`;
  const user = useSelector((state) => state.users.user);
  // console.log("user--",user);
  const userId = user?.userId || user?.id;
  const [userShowComments, setUserShowComments] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [printCertificate, setPrintCertificate] = useState(false);
  const [cerftificateUrl, setCertificateUrl] = useState();

  const [dropList, setDropList] = useState(false);
  const [modal, setModal] = useState({ pop: false, askQuestion: false });
  const [deleteResponse, setDeleteResponse] = useState();
  const [load, setLoad] = useState(false);
  const [revulsionModalStatus, setRevulsionModalStatus] = useState();
  const [nestedRepliesCollection, setNestedRepliesCollection] = useState(null);
  const [forumsUsersRepondDetails, setForumsUsersRespondDetails] = useState();
  useOutsideAlerter(wrapperRef);
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setDropList(!dropList);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const headerSelectableHandler = () => {
    setForumsHeaderDetails(`- ${element.title}`);
  };

  const postDeleteHandler = async (currentIndex) => {
    try {
      const res = await axiosInstance.delete(
        `${REACT_APP_LOGIN_API_BASEURL}/forum/${currentIndex}`
      );

      setDeleteResponse(res.data.message);
      expungeUserRespond();
      setLoad(true);
      fetchUserForumPosts();
    } catch (error) {
      console.error("Error deleting post:", error);
    }
  };

  const expungeUserRespond = (currentIndex) => {
    setForumsInterrogate((current) =>
      current.filter((items) => items.id !== currentIndex)
    );
  };

  const getByIdRepliesCollectionHandler = async (currentIdIndex) => {
    
    setIsLoading(true);

    try {
      const res = await axiosInstance.get(
        `${REACT_APP_LOGIN_API_BASEURL}/forum/${currentIdIndex}`
      );

      const replies = res.data.data.replies;

      if (userShowComments) {
        //console.log("res.data.data.replies", replies);
        setForumsUsersRespondDetails(replies);
      } else {
       // console.log("res.data (userShowComments was false):", res.data);
        setForumsUsersRespondDetails(replies);
        setUserShowComments(true);
        setRevulsionModalStatus(null);
      }
    } catch (error) {
      console.error("Error fetching replies:", error);
    } finally {
      setIsLoading(false);
    }
  };


  const userQueryActionHandler = (
    userForumsactionCurrentId,
    userForumsDetails,
    currentStageLevel,
    previousPostIndex
  ) => {
    //console.log("userForumsactionCurrentId", userForumsactionCurrentId);
    if (userForumsactionCurrentId) {
      setRevulsionModalStatus({
        ...revulsionModalStatus,
        conceal: true,
        isEdit: true,
        forumsCourseId: userForumsDetails.courseid,
        forumsDescription: userForumsDetails.description,
        forumsTitle: userForumsDetails.title,
        currentForumsIndexId: userForumsDetails.id,
        currentState: currentStageLevel,
        previousPostId: previousPostIndex,
      });
    } else {
      setRevulsionModalStatus({
        ...revulsionModalStatus,
        conceal: true,
        isEdit: false,
        threadId: userForumsDetails?.id,
        forumsTitle: userForumsDetails.title,
        currentState: currentStageLevel,
        previousPostId: previousPostIndex,
      });
    }
  };

  const showHandler = (url) => {
    setCertificateUrl(url);
    setPrintCertificate(!printCertificate);
  };

  return (
    <>
      <div
        className="bg-white rounded-2xl shadow-lg p-6 mb-8 border border-gray-100 hover:shadow-2xl transition-shadow"
        onClick={headerSelectableHandler}
      >
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-full overflow-hidden bg-gray-200 flex items-center justify-center">
              {element?.profileImage ? (
                <img
                  alt="profile"
                  src={element?.profileImage}
                  className="object-cover w-full h-full"
                />
              ) : (
                <span className="text-gray-500 text-2xl font-bold">
                  {element?.firstName?.[0]}
                </span>
              )}
            </div>
            <div>
              <div className="font-semibold text-gray-800 text-lg">
                {element?.firstName} {element?.lastName}
              </div>
              <div className="text-xs text-gray-400">{element?.title}</div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-xs text-gray-400">
              {moment(element?.time).format("MM/DD/YYYY")}
            </span>
            {element?.userId === userId && (
              <div className="relative ml-2">
                <button
                  className="p-1 rounded-full hover:bg-gray-100"
                  onClick={e => {
                    e.stopPropagation();
                    setDropList({ ...dropList, question: !dropList.question });
                  }}
                >
                  <svg className="w-5 h-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                    <circle cx="4" cy="10" r="2" />
                    <circle cx="10" cy="10" r="2" />
                    <circle cx="16" cy="10" r="2" />
                  </svg>
                </button>
                {dropList.question && (
                  <div className="!absolute right-0 mt-2 w-32 bg-white border border-gray-200 rounded-lg shadow-lg z-10" ref={wrapperRef}>
                    <ul>
                      {!element.replies > 0 && (
                        <li
                          className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm text-gray-700"
                          onClick={() => userQueryActionHandler(true, element)}
                        >
                          Edit
                        </li>
                      )}
                      <li
                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm text-red-500"
                        onClick={() => postDeleteHandler(element.id)}
                      >
                        Delete
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="mb-4">
          <p className="text-gray-700 mb-3">{element?.description}</p>
          {/* <div className="flex flex-wrap gap-3 mb-2">
            {Array.isArray(element?.files) &&
              element.files.map((file, key) => {
                const fileUrl = getS3URL(file.objectKey || `${file.folder}/${file.fileName}`);

                if (!fileUrl || !file.fileName) {
                  return (
                    <div key={key} className="text-red-500">
                      File not found
                    </div>
                  );
                }
                return (
                  <div key={key} className="w-full rounded-lg border border-gray-200 p-2 bg-gray-50">
                    {file?.fileName?.includes("pdf") ||
                      file?.fileName?.includes("xlsx") ||
                      file?.fileName?.includes("docx") ||
                      file?.fileName?.includes("ppt") ||
                      file?.fileName?.includes("pptx") ? (
                      <span
                        className="text-blue-600 underline cursor-pointer"
                        onClick={() => {
                          if (fileUrl && fileUrl.startsWith("http")) {
                            showHandler(fileUrl);
                          } else {
                            alert("File not found.");
                          }
                        }}
                      >
                        {file.fileName}
                      </span>
                    ) : file?.fileName?.includes("mp4") ||
                      file?.fileName?.includes("mov") ? (
                      fileUrl && fileUrl.startsWith("http") ? (
                        <video src={fileUrl} alt="forum-video" controls className="w-full h-[400px] rounded" />
                      ) : (
                        <span>Video not found</span>
                      )
                    ) : (
                      fileUrl && fileUrl.startsWith("http") ? (
                        <img src={fileUrl} alt="forum-image" className="w-full h-[400px] object-cover rounded"
                        onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = require("../../../../assets/images/bgimages.webp");
                              }}
                        />
                      ) : (
                        <span>Image not found</span>
                      )
                    )}
                  </div>
                );
              })}
          </div> */}
          <div className="flex flex-wrap gap-3 mb-2">
            {element.medialink ? (
              <div className="w-full rounded-lg border border-gray-200 p-2 bg-gray-50">
                {element.medialink.match(/\.(mp4|mov)$/i) ? (
                  <video src={element.medialink} controls className="w-full h-[400px] rounded" />
                ) : element.medialink.match(/\.(pdf|xlsx|docx|ppt|pptx)$/i) ? (
                  <a
                    href={element.medialink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline cursor-pointer"
                  >
                    {element.medialink.split("/").pop()}
                  </a>
                ) : (
                  <img
                    src={element.medialink}
                    alt="forum-media"
                    className="w-full h-[400px] object-cover rounded"
                    onError={e => {
                      e.target.onerror = null;
                      e.target.src = require("../../../../assets/images/bgimages.webp");
                    }}
                  />
                )}
              </div>
            ) : (
              Array.isArray(element?.files) &&
              element.files.map((file, key) => {
                const fileUrl = getS3URL(file.objectKey || `${file.folder}/${file.fileName}`);
                if (!fileUrl || !file.fileName) {
                  return (
                    <div key={key} className="text-red-500">
                      File not found
                    </div>
                  );
                }
                return (
                  <div key={key} className="w-full rounded-lg border border-gray-200 p-2 bg-gray-50">
                    {file?.fileName?.includes("pdf") ||
                      file?.fileName?.includes("xlsx") ||
                      file?.fileName?.includes("docx") ||
                      file?.fileName?.includes("ppt") ||
                      file?.fileName?.includes("pptx") ? (
                      <span
                        className="text-blue-600 underline cursor-pointer"
                        onClick={() => {
                          if (fileUrl && fileUrl.startsWith("http")) {
                            showHandler(fileUrl);
                          } else {
                            alert("File not found.");
                          }
                        }}
                      >
                        {file.fileName}
                      </span>
                    ) : file?.fileName?.includes("mp4") ||
                      file?.fileName?.includes("mov") ? (
                      fileUrl && fileUrl.startsWith("http") ? (
                        <video src={fileUrl} alt="forum-video" controls className="w-full h-[400px] rounded" />
                      ) : (
                        <span>Video not found</span>
                      )
                    ) : (
                      fileUrl && fileUrl.startsWith("http") ? (
                        <img
                          src={fileUrl}
                          alt="forum-image"
                          className="w-full h-[400px] object-cover rounded"
                          onError={e => {
                            e.target.onerror = null;
                            e.target.src = require("../../../../assets/images/bgimages.webp");
                          }}
                        />
                      ) : (
                        <span>Image not found</span>
                      )
                    )}
                  </div>
                );
              })
            )}
          </div>
        </div>

        <div className="flex items-center gap-4 mt-2">
          {element.replies > 0 && (
            <button
              className="text-blue-600 text-sm font-medium hover:underline"
              onClick={e => {
                e.stopPropagation();
                forumsUsersRepondDetails?.length > 0
                  ? setUserShowComments(!userShowComments)
                  : getByIdRepliesCollectionHandler(element.id);
              }}
            >
              {element.replies} comments
            </button>
          )}
          <button
            className="bg-blue-50 text-blue-700 px-4 py-1 rounded hover:bg-blue-100 text-sm font-medium"
            onClick={e => {
              e.stopPropagation();
              userQueryActionHandler(false, element, "levelZero");
            }}
          >
            Reply
          </button>
        </div>

        {userShowComments && (
          <div className="sub-commentbox mt-6">
            {forumsUsersRepondDetails &&
              forumsUsersRepondDetails.length > 0 &&
              forumsUsersRepondDetails.map((commnetsdata, index) => (
                <ForumReplies
                  commnetsdata={commnetsdata}
                  index={index}
                  userId={userId}
                  userQueryActionHandler={userQueryActionHandler}
                  setDeleteResponse={setDeleteResponse}
                  getByIdRepliesCollectionHandlers={getByIdRepliesCollectionHandler}
                  setLoad={setLoad}
                  previousPostIndex={element.id}
                  nestedRepliesCollection={nestedRepliesCollection}
                  setForumsUsersRespondDetails={setForumsUsersRespondDetails}
                  fetchUserForumPosts={fetchUserForumPosts}
                />
              ))}
          </div>
        )}

        {isLoading && <Loading />}

        {load && (
          // <OverlayContainer>
          <>
            <div className="forms-width-reply add-reply">
              <div className="submission_PopUp">
                <div className="preview-close" onClick={() => setLoad(!load)}>
                  <div>
                    <i className="icon check"></i>
                  </div>
                </div>
                <div className="item-popup-text">
                  <img
                    src={submissionPopUpCheckmarkUrl}
                    alt="Image Not Found"
                  />
                  <p>{deleteResponse}</p>
                </div>
              </div>
            </div>
            {/* </OverlayContainer> */}
          </>
        )}

        {revulsionModalStatus?.conceal && (
          // <OverlayContainer>
          <ReplyModal
            revulsionModalStatus={revulsionModalStatus}
            setRevulsionModalStatus={setRevulsionModalStatus}
            getByIdRepliesCollectionHandler={getByIdRepliesCollectionHandler}
            setModal={setModal}
            modal={modal}
            forumId={forumId}
            setForumId={setForumId}
            cId={element.courseid}
            fetchUserForumPosts={fetchUserForumPosts}
            title={element.title}
            setNestedRepliesCollection={setNestedRepliesCollection}
            studentPurchasedCourseDetails={studentPurchasedCourseDetails}
          />
          // </OverlayContainer>
        )}
      </div>
      {printCertificate && (
        // <OverlayContainer>
        <ChapterDocument
          type={"pdf"}
          url={cerftificateUrl}
          closeHandler={showHandler}
          show={printCertificate}
        />
        // </OverlayContainer>
      )}
    </>
  );
};
export default PostComments;
